export const environment = {
  production: false,
  version: '0.0.1',
  useTracing: false,
  api: {
    info: 'https://api.dev1.wrebit.helops.net',
    admin: 'https://api.dev1.wrebit.helops.net',
    bookkeep: 'https://api.dev1.wrebit.helops.net',
    chat: 'https://api.dev1.wrebit.helops.net',
    imageRead: 'https://fr-tf.wrebit.helops.net',
  },
  analytics: {
    measurementCode: '',
  },
};
